import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const CustomerOfferSearch = lazy(() => import("../components/CustomerOfferSearch"));

const CustomerOfferSearchRoute: RouteObject = {
  path: "/customer-offers",
  element: <CustomerOfferSearch />,
};

export default CustomerOfferSearchRoute;
